/* lua.js generated code 0.3.0 */

var __kTexturePixelFormat__ = table()
SpriteUtil = table()
SpriteUtil.buildAnimatedSprite = function (timePerFrame, pattern, begin, length, isReversed) {
    var frames = SpriteUtil.buildFrames(pattern, begin, length, isReversed)
    var sprite = cc.Sprite.createWithSpriteFrame(frames[1])
    var animate = SpriteUtil.buildAnimate(frames, timePerFrame)
    return [Sprite.new(sprite), animate]
}
//Creates a sprite that it's texture repeated to fill the whole content area.
SpriteUtil.buildRepeatedSprite = function (fileName, repeatRect) {
    if (!fileName) {
        cc.log("build repeated sprite fail. no filename")
        return 
    }
    if (!repeatRect) {
        var winsize = cc.Director.getInstance().getWinSize()
        repeatRect = CCRectMake(0, 0, winsize.width, winsize.height)
    }
    var p = ccTexParams()
    p.minFilter = GL_LINEAR
    p.magFilter = GL_LINEAR
    p.wrapS = GL_REPEAT
    p.wrapT = GL_LINEAR
    var sprite = cc.Sprite.create(fileName, repeatRect)
    sprite.getTexture().setTexParameters(p)
    // WARN: maybe multi result
    return Sprite.new(sprite)
}
// mapping texture's CCTexture2DPixelFormat with filename.
// common use: kTexture2DPixelFormat_RGB565 kTexture2DPixelFormat_RGB888 kTexture2DPixelFormat_RGBA8888 
// kTexture2DPixelFormat_RGBA4444 kTexture2DPixelFormat_RGB5A1 kCCTexture2DPixelFormat_A8
// kCCTexture2DPixelFormat_PVRTC4 kCCTexture2DPixelFormat_PVRTC2
SpriteUtil.setTexturePixelFormat = function (fileName, pixelFormat) {
    __kTexturePixelFormat__[fileName] = pixelFormat
}
//Adds multiple Sprite Frames from a plist file. The texture will be associated with the created sprite frames.
// if texture contains special pixel format, use setTexturePixelFormat first.
var loadedPlistSprite = table()
var scaledResource = table()
SpriteUtil.addSpriteFrames = function (plistFilename, textureFileName) {

    //cc.log('util.addSpriteFrames:'+plistFilename)

    var prefix = plistFilename.split(".")[0]
    if (loadedPlistSprite[plistFilename]) {
        return [plistFilename, textureFileName]
    }
    var sharedSpriteFrameCache = cc.spriteFrameCache
    if (__kTexturePixelFormat__[textureFileName]) {
        cc.Texture2D.setDefaultAlphaPixelFormat(__kTexturePixelFormat__[textureFileName])
        sharedSpriteFrameCache.addSpriteFrames(plistFilename, textureFileName)
        cc.Texture2D.setDefaultAlphaPixelFormat(cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A8888)
        loadedPlistSprite[plistFilename] = true
    } else {
        sharedSpriteFrameCache.addSpriteFrames(plistFilename, textureFileName)
        loadedPlistSprite[plistFilename] = true
    }
    if (_G.__use_small_res) {
        var path = prefix + "@6x" + ".png"
        var t2d = cc.Director.getInstance().getTextureCache().getTextureForKey(path)
        if (!t2d) {
            path = textureFileName
            t2d = cc.Director.getInstance().getTextureCache().getTextureForKey(path)
        }
        if (t2d) {
            t2d.setTexParameters(gl.LINEAR, gl.LINEAR, gl.CLAMP_TO_EDGE, gl.CLAMP_TO_EDGE)
        }
    }
    return [plistFilename, textureFileName]
}
SpriteUtil.removeLoadedPlist = function (plistFilename) {
    if (plistFilename && loadedPlistSprite[plistFilename] != null) {
        loadedPlistSprite[plistFilename] = null
    }
}
SpriteUtil.cacheTexture = function (textureFileName) {
    if (__kTexturePixelFormat__[textureFileName]) {
        cc.Texture2D.setDefaultAlphaPixelFormat(__kTexturePixelFormat__[textureFileName])
        cc.Director.getInstance().getTextureCache().addImage(textureFileName)
        cc.Texture2D.setDefaultAlphaPixelFormat(cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A8888)
    } else {
        cc.Director.getInstance().getTextureCache().addImage(textureFileName)
    }
}
//Creates multiple frames by pattern.
// Example:
// create array of CCSpriteFrame [walk0001.png -> walk0020.png]
// local frames = SpriteUtil:buildFrames("walk%04d.png", 1, 20)
SpriteUtil.buildFrames = function (pattern, begin, length, isReversed, forceNotHalf = false) {
    if (!pattern) {
        cc.log("build frames fail. no pattern")
        return 
    }
    //cc.log('util.buildFrames:'+pattern)
    //https://github.com/dualface/quick-cocos2d-x/blob/master/framework/client/display.lua#newFrames
    var sharedSpriteFrameCache = cc.spriteFrameCache
    var frames = sTable()
    var step = 1
    var last = begin + length - 1
    if (isReversed) {
        ;[last, begin] = [begin, last]
        step = -1
    }
    var $var25 = begin,$limit26 = last,$step27 = step
    for (var index = $var25; ($step27 > 0 && index <= $limit26) || ($step27 < 0 && index >= $limit26); index += $step27) {
        if (HALF_FRAME && !forceNotHalf && index % 2 === 1){
            // console.log("skip "+string.format(pattern, index))
            continue
        }
        var frameName = string.format(pattern, index)
        var frame = sharedSpriteFrameCache.getSpriteFrame(frameName)
        if (!frame) {
            cc.log("invalid frame, name %s", frameName)
        }
        frames[$len(frames) + 1] = frame
    }
    return frames
}
//Creates multiple frames by pattern.
// Example:
// create array of CCSpriteFrame [walk0001.png -> walk0020.png]
// local frames = SpriteUtil:buildFrames("walk%04d.png", 1, 20)
SpriteUtil.buildFramesByStep = function (pattern, begin, length, isReversed, step = 1, forceNotHalf = false) {
    if (!pattern) {
        cc.log("build frames fail. no pattern")
        return 
    }
    //cc.log('util.buildFrames:'+pattern)
    //https://github.com/dualface/quick-cocos2d-x/blob/master/framework/client/display.lua#newFrames
    var sharedSpriteFrameCache = cc.spriteFrameCache
    var frames = sTable()
    if (step == null){}
    var last = begin + length - 1
    if (isReversed) {
        ;[last, begin] = [begin, last]
        step = 0 - step
    }
    var $var25 = begin,$limit26 = last,$step27 = step
    for (var index = $var25; ($step27 > 0 && index <= $limit26) || ($step27 < 0 && index >= $limit26); index += $step27) {
        if (HALF_FRAME && !forceNotHalf && index % 2 === 1) continue
        var frameName = string.format(pattern, index)
        var frame = sharedSpriteFrameCache.getSpriteFrame(frameName)
        if (!frame) {
            cc.log("invalid frame, name %s", frameName)
        }
        frames[$len(frames) + 1] = frame
    }
    console.log("[buildFramesByStep]", frames)
    return frames
}
// Example:
//  local frames    = SpriteUtil:buildFrames("walk_%02d.png", 1, 20)
//  local animation = SpriteUtil:buildAnimate(frames, 0.5 / 20) -- in 0.5s play 20 frames
SpriteUtil.buildAnimate = function (frames, time, restore, forceNotHalf = false) {
    //https://github.com/dualface/quick-cocos2d-x/blob/master/framework/client/display.lua#newAnimation
    var count = $len(frames)
    var array = LuaArray.create()
    var $limit34 = count
    for (var i = 1; i <= $limit34; i += 1) {
        array.addObject(frames[i])
    }
    if (!time) {
        time = 1 / count
    }
    if (HALF_FRAME && !forceNotHalf) {
        time *= 2
    }
    var animation = cc.Animation.createWithSpriteFrames(array.toLuaArray(), time)
    if (restore) {
        animation.setRestoreOriginalFrame(true)
    }
    // WARN: maybe multi result
    return cc.Animate.create(animation)
}
//从父节点中移除自身
//sp只要是node就行
SpriteUtil.removeFromParent = function (sp, cleanup) {
    var parentContainer
    if (sp != null) {
        parentContainer = sp.getParent()
        if (parentContainer != null) {
            parentContainer.removeChild(sp, cleanup)
            sp = null
        }
    }
}
//---------------------------------
//layer时貌似，不准确
//---------------------------------
SpriteUtil.isWorldPosInNode = function (pos, node) {
    var locationInNode = node.getParent().convertToNodeSpace(pos)
    var size = node.getContentSize()
    var rect = node.getBoundingBox()
    if (cc.rectContainsPoint(rect, locationInNode)) {
        return true
    }
    return false
}
SpriteUtil.addTouchListener = function (node, beginTouch, moveTouch, endTouch, cancelTouch) {
    function touchBegin(touch, evt) {
        // body
        if (SpriteUtil.isWorldPosInNode(touch.getLocation(), node)) {
            if (beginTouch) {
                beginTouch(touch, evt)
            }
            return true
        }
        return false
    }
    function touchMove(touch, evt) {
        // body
        if (SpriteUtil.isWorldPosInNode(touch.getLocation(), node)) {
            if (moveTouch) {
                moveTouch(touch, evt)
            }
            return true
        }
        return false
    }
    function touchEnd(touch, evt) {
        // body
        if (SpriteUtil.isWorldPosInNode(touch.getLocation(), node)) {
            if (endTouch) {
                endTouch(touch, evt)
            }
            return true
        } else if (cancelTouch) {
            cancelTouch()
        }
        return false
    }
    var listener = cc.EventListenerTouchOneByOne.create()
    listener.setSwallowTouches(true)
    listener.registerScriptHandler(touchBegin, cc.Handler.EVENT_TOUCH_BEGAN)
    listener.registerScriptHandler(touchMove, cc.Handler.EVENT_TOUCH_MOVED)
    listener.registerScriptHandler(touchEnd, cc.Handler.EVENT_TOUCH_ENDED)
    node.getEventDispatcher().addEventListenerWithSceneGraphPriority(listener, node)
    return listener
}
SpriteUtil.removeTouchListener = function (node, listener) {
    node.getEventDispatcher().removeEventListener(listener)
}
SpriteUtil.addSpriteFrameCacheAsync = function (plistFilename, textureFileName, completeCallback) {
    if (loadedPlistSprite[plistFilename]) {
        return [plistFilename, textureFileName]
    }
    function textureLoaded(tex) {
        // print("Async load texture:", textureFileName)
        if (__kTexturePixelFormat__[textureFileName]) {
            cc.Texture2D.setDefaultAlphaPixelFormat(__kTexturePixelFormat__[textureFileName])
            FrameLoader.loadImageWithPlist(plistFilename)
            cc.Texture2D.setDefaultAlphaPixelFormat(cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A8888)
        } else {
            FrameLoader.loadImageWithPlist(plistFilename)
        }
        loadedPlistSprite[plistFilename] = true
        if (completeCallback && type(completeCallback) === "function") {
            completeCallback()
        }
    }
    cc.Director.getInstance().getTextureCache().addImageAsync(textureFileName, textureLoaded)
    return [plistFilename, textureFileName]
}
SpriteUtil.getDefSmallIcon = function (defId, dir) {
    let self = this
    // body
    let frameName = string.format("block_machine/def_icon_%d.png", defId)
    if ($bool(dir)) {
        frameName = string.format("block_machine/def_icon_%d_%d.png", defId,dir);
    }
    let frame = cc.spriteFrameCache.getSpriteFrame(frameName)
    if (frame) {
        let defIcon = cc.Sprite.createWithSpriteFrame(frame)
        return defIcon
    } else {
        return null
    }
}
// 找出所有需要添加叠加效果的子节点（以blend_开头），并添加blend效果
SpriteUtil.addBlend = function (sp, blendFunc, forceUse) {
    let self = this
    let prefix = "blend_"
    let spName = sp.getName()
    if (string.starts(spName, prefix) || forceUse) {
        if (type(sp.setBlendFunc) === "function") {
            sp.setBlendFunc(blendFunc)
        }
        forceUse = true
    }
    let $st54 = sp.getChildren()
    for (let _ in $st54) {
        let child = $st54[_]
        if ($null(child)) continue
        SpriteUtil.addBlend(child, blendFunc, forceUse)
    }
}
SpriteUtil.findBlendChilds_AddSrcalphaOne = function (sp, forceUse) {
    let self = this
    SpriteUtil.addBlend(sp, table([1, "src", gl.SRC_ALPHA], [1, "dst", gl.ONE]), forceUse)
}
SpriteUtil.findBlendChilds_AddOneOne = function (sp, forceUse) {
    let self = this
    SpriteUtil.addBlend(sp, table([1, "src", gl.ONE], [1, "dst", gl.ONE]), forceUse)
}
